
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.335 6.247a1.018 1.018 0 000 1.509l5.713 5.331a1.203 1.203 0 001.617 0 1.018 1.018 0 000-1.51L2.76 7 7.662 2.42a1.018 1.018 0 000-1.509 1.203 1.203 0 00-1.618 0L.331 6.243l.004.004z","fill":"#313131"}})])
          )
        }
      }
    